
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {ClientLoginInfoRecord} from '../core/ClientLoginInfoRecord';
import {FieldModelClientLoginInfoRecord} from '../core/ClientLoginInfoRecord';

/**
 * ClientLoginInfoGetResponse struct
 */
class ClientLoginInfoGetResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {number=} lastRecordId
   * @param {!Array=} clientLoginInfoRecords
   * @constructor
   */
  constructor (parent = new Response(), lastRecordId = null, clientLoginInfoRecords = []) {
    super()
    super.copy(parent)
    this.LastRecordId = lastRecordId
    this.ClientLoginInfoRecords = clientLoginInfoRecords
  }

  /**
   * Copy struct (shallow copy)
   * @this {!ClientLoginInfoGetResponse}
   * @param {!ClientLoginInfoGetResponse} other Other struct
   * @returns {!ClientLoginInfoGetResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.LastRecordId != null) {
      this.LastRecordId = UInt64.fromNumber(other.LastRecordId)
    } else {
      this.LastRecordId = null
    }
    if (other.ClientLoginInfoRecords != null) {
      this.ClientLoginInfoRecords = []
      for (let item of other.ClientLoginInfoRecords) {
        if (item != null) {
          let tempItem
          tempItem = ClientLoginInfoRecord.fromObject(item)
          this.ClientLoginInfoRecords.push(tempItem)
        } else {
          this.ClientLoginInfoRecords.push(null)
        }
      }
    } else {
      this.ClientLoginInfoRecords = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!ClientLoginInfoGetResponse}
   * @returns {!ClientLoginInfoGetResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new ClientLoginInfoGetResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new ClientLoginInfoGetResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!ClientLoginInfoGetResponse}
   * @param {!ClientLoginInfoGetResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ClientLoginInfoGetResponse)) {
      throw new TypeError('Instance of ClientLoginInfoGetResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!ClientLoginInfoGetResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      LastRecordId: ((this.LastRecordId != null) ? this.LastRecordId.toNumber() : null),
      ClientLoginInfoRecords: ((this.ClientLoginInfoRecords != null) ? Array.from(this.ClientLoginInfoRecords, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return ClientLoginInfoGetResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!ClientLoginInfoGetResponse} other Object value
   * @returns {!ClientLoginInfoGetResponse} Created struct
   */
  static fromObject (other) {
    return new ClientLoginInfoGetResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!ClientLoginInfoGetResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return ClientLoginInfoGetResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!ClientLoginInfoGetResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4101
  }
}

export { ClientLoginInfoGetResponse };

/**
 * Fast Binary Encoding ClientLoginInfoGetResponse field model
 */
class FieldModelClientLoginInfoGetResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.LastRecordId = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.ClientLoginInfoRecords = new fbe.FieldModelVector(new FieldModelClientLoginInfoRecord(buffer, this.LastRecordId.fbeOffset + this.LastRecordId.fbeSize), buffer, this.LastRecordId.fbeOffset + this.LastRecordId.fbeSize)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelClientLoginInfoGetResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelClientLoginInfoGetResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelClientLoginInfoGetResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.LastRecordId.fbeSize + this.ClientLoginInfoRecords.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelClientLoginInfoGetResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.LastRecordId.fbeExtra + this.ClientLoginInfoRecords.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelClientLoginInfoGetResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelClientLoginInfoGetResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelClientLoginInfoGetResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4101
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelClientLoginInfoGetResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelClientLoginInfoGetResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.LastRecordId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.LastRecordId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastRecordId.fbeSize

    if ((fbeCurrentSize + this.ClientLoginInfoRecords.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClientLoginInfoRecords.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientLoginInfoRecords.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelClientLoginInfoGetResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelClientLoginInfoGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelClientLoginInfoGetResponse}
   * @param {!ClientLoginInfoGetResponse} fbeValue Default value, defaults is new ClientLoginInfoGetResponse()
   * @returns {!ClientLoginInfoGetResponse} ClientLoginInfoGetResponse value
   */
  get (fbeValue = new ClientLoginInfoGetResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelClientLoginInfoGetResponse}
   * @param {!ClientLoginInfoGetResponse} fbeValue ClientLoginInfoGetResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.LastRecordId.fbeSize) <= fbeStructSize) {
      fbeValue.LastRecordId = this.LastRecordId.get()
    } else {
      fbeValue.LastRecordId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.LastRecordId.fbeSize

    if ((fbeCurrentSize + this.ClientLoginInfoRecords.fbeSize) <= fbeStructSize) {
      this.ClientLoginInfoRecords.get(fbeValue.ClientLoginInfoRecords)
    } else {
      fbeValue.ClientLoginInfoRecords.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientLoginInfoRecords.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelClientLoginInfoGetResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelClientLoginInfoGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelClientLoginInfoGetResponse}
   * @param {!ClientLoginInfoGetResponse} fbeValue ClientLoginInfoGetResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelClientLoginInfoGetResponse}
   * @param {ClientLoginInfoGetResponse} fbeValue ClientLoginInfoGetResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.LastRecordId.set(fbeValue.LastRecordId)
    this.ClientLoginInfoRecords.set(fbeValue.ClientLoginInfoRecords)
  }
}

export { FieldModelClientLoginInfoGetResponse };

/**
 * Fast Binary Encoding ClientLoginInfoGetResponse model
 */
class ClientLoginInfoGetResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelClientLoginInfoGetResponse(this.buffer, 4)
  }

  /**
   * Get the ClientLoginInfoGetResponse model
   * @this {!ClientLoginInfoGetResponseModel}
   * @returns {!FieldModelClientLoginInfoGetResponse} model ClientLoginInfoGetResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!ClientLoginInfoGetResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!ClientLoginInfoGetResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return ClientLoginInfoGetResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!ClientLoginInfoGetResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelClientLoginInfoGetResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!ClientLoginInfoGetResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!ClientLoginInfoGetResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!ClientLoginInfoGetResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!ClientLoginInfoGetResponseModel}
   * @param {!ClientLoginInfoGetResponse} value ClientLoginInfoGetResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!ClientLoginInfoGetResponseModel}
   * @param {!ClientLoginInfoGetResponse} value ClientLoginInfoGetResponse value, defaults is new ClientLoginInfoGetResponse()
   * @return {!object} Deserialized ClientLoginInfoGetResponse value and its size
   */
  deserialize (value = new ClientLoginInfoGetResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new ClientLoginInfoGetResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new ClientLoginInfoGetResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!ClientLoginInfoGetResponseModel}
   * @param {!number} prev Previous ClientLoginInfoGetResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { ClientLoginInfoGetResponseModel };
